/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'AI review',
    AIReviewFailed: 'AI review failed',
    AIReviewPassed: 'AI review passed',
    AIReviewStatus: 'AI review status',
    AIReviewing: 'AI review is being reviewed',
    America: 'United States',
    CheckSupportInstall: 'Check if retrofitting is supported',
    ImporterCommunityDisplayName: 'Importer community display name',
    ImporterContactEmail: 'Importer contact e-mail',
    IndicatorLight: 'Indicator light',
    Instruction: 'Notice',
    MostPicture4OrVideo: 'Image size should be less than 5 MB, video size should be less than 50 MB',
    PleaseContactPersonnelCommunicating: 'Please contact CFMOTO personnel for communicating',
    USD: 'USD',
    UnbindingApplicationCommitment: 'Commitment for unbinding application',
    aboutAccount: 'About account',
    aboutVehicle: 'About vehicle',
    accountApplyRejected: 'Account deletion request rejected',
    accountCancel: 'Account deletion request',
    accountDeletExplain: 'Account deletion guidance',
    accountDelete: 'Account deletion',
    accountDeleted: 'Account deleted',
    accountFormatError: 'Incorrect account format/user does not exist. Please match the corresponding copywriting based on the actual cause.',
    action: 'Operation',
    actionFail: 'Operation failed',
    actionSuccess: 'Operation succeeded',
    activeScore: 'Active scoring',
    activeTrigger: 'Users actively trigger (About app — go to rating)',
    activity: 'Activity',
    activityCancel: 'Event cancellation',
    activityCover: 'Activity cover',
    activityDetails: 'Activity details',
    activityId: 'Activity ID',
    activityList: 'List of activities',
    activityManagement: 'Activity management',
    activitySearch: 'Activity search',
    activityTime: 'Activity time',
    activityTitle: 'Activity title',
    activityVenue: 'Activity venue',
    adaptable: 'Fits for',
    add: 'Add',
    addAccountDeletExplain: 'Add account deletion notes',
    addAuthenticationTime: 'Add authentication time',
    addDataDeletExplain: 'Add data deletion notes',
    addEmail: 'New email',
    addExhibitionCategory: 'Add Shop Category',
    addExhibitionSeries: 'Add New Series',
    addInformationCategory: 'Add new information category',
    addInformationContent: 'Add new information content',
    addKolUserAuthentication: 'Add KOL user authentication',
    addPicture: 'Add picture',
    addPrivacyAgreement: 'Add privacy agreement',
    addPrivacySubmitSure: 'The effective date and change description of the new privacy policy cannot be adjusted after submission. Confirm submission?',
    addPushConfiguration: 'Add push configuration',
    addQuestion: 'Add question',
    addSdkStaement: 'Add SDK Statement',
    addServiceIntroduce: 'Introduction of new services',
    addShowroomModel: 'Add showroom models',
    addThisUser: 'Add this user',
    addTopic: 'Add a topic',
    addUser: 'Add user',
    addUserAgreement: 'Add user agreement',
    addUserRole: 'Add User Role',
    addVehicleModel: 'New models',
    addVehicleModelCategory: 'New vehicle category',
    addVideo: 'Add video',
    addedBy: 'Added by',
    additionalFeedback: 'Additional Feedback',
    administratorUnbind: 'Administrator unbind',
    afternoon: 'afternoon',
    agreeSignOut: 'Agree to terminate',
    agreementContent: 'Agreement',
    all: 'All',
    allArea: 'Target country/region',
    allComment: 'All comments',
    allImportSuccess: 'Import completed. Everything imported successfully.',
    allUser: 'All users',
    allVehicleModel: 'All models',
    alreadyOver: 'No more records here',
    android: 'Android',
    answer: 'Answer',
    answerOta1: 'OTA means that the vehicle downloads the latest firmware software from the cloud through the cellular network, and you can upgrade the vehicle online through CFMOTO RIDE to continuously optimize the riding experience',
    answerOta2: 'When new version of the tft display that can be upgraded, you will receive the upgrade notification. If %s is displayed at the bottom of the current page, means that the vehicle tft display does not need to be upgraded.',
    answerOta3: 'You can click %s in the upper right corner to learn more OTA operation instructions in advance',
    anyCar: 'Any car?',
    appRating: 'Scoring mechanism management',
    appType: 'Phone system',
    appVersion: 'App version',
    applicableCountry: 'Applicable countries',
    applicableCountryName: 'Applicable countries',
    applyTime: 'Application time',
    applyUnbinding: 'Apply unbinding',
    appointmentReleaseTime: 'Appointment release time',
    approval: 'Approval',
    arrivalNumberDescription: 'The actual number of arrivals at the device terminal after the notification message is sent (arrivals after 5 days will not be counted)',
    arrivalNumberVolume: 'Number of arrivals',
    askAllowUserSpeakInCommunity: 'Allow the banned user to post in the community',
    askApproveIt: 'Approve it',
    askDeleteCategory: 'Delete this category',
    askDeleteInformactionCategory: 'Delete this information category?',
    askDeleteInformationContent: 'Delete information content?',
    askDeleteKolUserAuthentication: 'Are you sure to delete this KOL user authentication?',
    askDeleteQuestion: 'Delete this question',
    askDeleteThisActivity: 'Delete this activity',
    askDeleteThisBanner: 'Delete this Banner',
    askDeleteThisComment: 'Sure you want to delete this comment',
    askDeleteThisPost: 'Delete this post',
    askDeleteThisTopic: 'Delete this topic',
    askDeleteVehicleType: 'Delete the vehicle model?',
    askDeleteVehicleTypeCategory: 'Delete this model category?',
    askDeleteVehicleTypeDetails: 'Delete the model details?',
    askDeleteVehicleTypeSeries: 'Delete this model series?',
    askLogout: 'Are you sure you want to exit?',
    askNotApproveIt: 'Not to approve it',
    askSaveSettings: 'The settings have not been saved yet. Do you want to save them?',
    associatedPostNumber: 'Number of associated posts',
    associatedPosts: 'Associated posts',
    associatedVehicle: 'Associated vehicle',
    assoclatedContent: 'Associated content',
    atmosphereCContent: 'The settings have not been saved yet, do you want to save them?',
    atmosphereContent1Msg1: 'After the function is turned on, the mobile phone turns on Bluetooth, and the app keeps running. ',
    atmosphereContent1Msg2: 'When the vehicle is locked, powered off, and nearby, it can be automatically unlocked and powered on by pressing the unlock button.',
    atmosphereContent1Msg3: 'Auto-unlock will be triggered only once before Bluetooth is disconnected.',
    atmosphereContent2Msg1: "After the function is turned on, the vehicle will automatically power off 5 seconds after 3 conditions are met: the engine has been turned off, the vehicle's speed is 0, and the side stand is down.",
    atmosphereContent2Msg2: 'Automatic power-off will be canceled if these 3 conditions are not met.',
    atmosphereContent3Msg1: 'After the function is turned on, the mobile phone turns on Bluetooth, and the app keeps running. When the vehicle is powered off and nearby, its lights will flash.',
    atmosphereContent3Msg2: 'If the function is triggered twice within 30 seconds, it will not resume until 30 minutes later to prevent frequent triggers from causing vehicle power loss.',
    atmosphereContent4Msg1: 'After the function is turned on, the headlights will be turned on automatically for 10 seconds after the vehicle is powered off',
    atmosphereIntroduce1: 'Auto unlock instructions',
    atmosphereIntroduce2: 'Auto power off instructions',
    atmosphereIntroduce3: 'Auto wake up instructions',
    atmosphereIntroduce4: 'Delayed lights off',
    atmosphereSetINfo: 'The new settings will take effect within 1-3 minutes after the vehicle is powered on. Please make sure the vehicle is in a good signal position.',
    auditStatus: 'Approval status',
    authenticatedName: 'Authenticated name',
    avatar: 'Avatar',
    backApply: 'Withdraw application',
    backApplySuccess: 'Application successfully withdrawn',
    backHome: 'Back to home page',
    bannerDisplayImages: 'Banner picture',
    bannerList: 'Banner list',
    bannerManagement: 'Banner management',
    bannerPictrure: 'Banner drawing',
    bannerSearch: 'Banner search',
    bannerTitle: 'Banner title',
    batchImport: 'Batch import',
    batchUser: 'Batch users',
    beijingTime: 'UTC+8 time',
    belogCategory: 'Category',
    belongCategory: 'Belonging Category',
    bindDevice: 'Bind device',
    bindVehicle: 'Bind vehicle',
    bindingStatus: 'Binding status',
    bindingText1: '1.\tTelematics Services',
    bindingText10: '1.1.2.\tProviding route-planning during navigation, including calculating the distance between vehicles and walking navigation for the purpose of finding a vehicle.',
    bindingText11: '1.2.\tSending necessary notifications to the Customer based on the conditions of the vehicle.',
    bindingText12:
      '1.2.1.\tCFMOTO will send the Customer notifications on vehicle maintenance (e.g. based on the total distance the Customer drive, the time when the Customer buy the vehicle, the time or driving distance requirements for vehicle maintenance).',
    bindingText13: '1.2.2.\tBased on vehicle data, CFMOTO will send the Customer abnormal situation notifications; including data analysis by OEM (depending on the model) to provide customer care and follow-up optimization of the vehicle.',
    bindingText14: '1.3.\tSupport in analyzing the cause of the accident if the Customer reports a serious accident of the Vehicle.',
    bindingText15:
      '1.3.1.\tIn the event of a serious accident of the Vehicle, such as when the Vehicle overturns or flips over on its side while driving, CFMOTO will support the Customer upon request in clarifying whether the accident is due to a defect in the Vehicle or other circumstances. The request is to be submitted to CFMOTO by the Customer via the local distributor / sales partner indicated in the Vehicle Sales Agreement.',
    bindingText16: '1.3.2.\tInsofar as the available data allow this, CFMOTO will evaluate the data in relation to the cause of the accident and provide the Customer with a corresponding report.',
    bindingText17: '1.4.\tAssistance for the Customer to recover the Vehicle after the Vehicle is lost.',
    bindingText18:
      '1.4.1.\tIf the Vehicle is lost, CFMOTO will provide the Customer with location data of the Vehicle and other useful status data of the Vehicle (such as location of last activation, current vehicle status, etc.) upon request and if available.',
    bindingText19: '1.4.2.\tThe request is to be submitted to CFMOTO by the Customer via the local distributor / sales partner indicated in the Vehicle Sales Agreement.',
    bindingText2:
      'CFMOTO Powersports, Inc.(hereinafter referred to as “CFMOTO”) provides vehicle telematics services to the customer who bought the CFMOTO vehicle(hereinafter referred to as “Customer”). For these services, CFMOTO uses data recorded by the Vehicle about the Vehicle and its driving behavior in the relevant period of time. In detail, this concerns the following data:',
    bindingText20: '1.5.\tReporting of after-sales problems.',
    bindingText21: '1.5.1.\tCFMOTO collects remotely error code notifications sent by the Vehicle in case of malfunction of its components and provides respective information upon Customer’s request directly to the Customer.',
    bindingText22: '1.5.2.\tThe request is to be submitted to CFMOTO by the Customer via the local distributor / sales partner indicated in the Vehicle Sales Agreement.',
    bindingText23: '2.\tRestrictions and Exclusions of Service',
    bindingText24: '2.1.\tIt is expressly pointed out that structural or other technical changes to the Vehicle can limit the provision of the services or even make it impossible, since the services depend on the correct provision of the vehicle data.',
    bindingText25: '2.2.\tWhere such the services cannot be provided due to the performance of any 3rd party data or telecommunication networks, any liability of CFMOTO is excluded. ',
    bindingText26: '3.\tPrivacy',
    bindingText27:
      "CFMOTO will comply with the applicable data protection regulations when processing personal data in connection with the CFMOTO vehicle. The terms of CFMOTO's privacy policy is set out in this CFMOTO RIDE APP. As a supplement to the privacy policy, this notice complies with the privacy policy. And the Customer can refer to the privacy policy for some data-processing related contents not covered by this notice.",
    bindingText28: '4.\tCustomer Service',
    bindingText29:
      '4.1.\tThe Customer can feel free to send privacy-related questions, comments or concerns to CFMOTORIDEAPP@cfmotousa.com or write to: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, MN 55447. The Customer may also call CFMOTO Customer Relations at (888) 823-6686. ',
    bindingText3: 'User Driving Behavior Data: including acceleration, deceleration, speed, bending, last driving time, and last driving mileage. ',
    bindingText30: '5.\tRevisions',
    bindingText31: '5.1.\tCFMOTO reserves the right to change this notice at any time, but we will publish revisions on CFMOTO RIDE App and/or provide notice before we do so as appropriate.',
    bindingText4:
      'Vehicle Status Data: refers to the real-time status of the Vehicle, including driving mode, residual fuel, instant fuel economy, mileage, real-time gear of the vehicle, engine speed, tire pressure, tire temperature, battery activation voltage data, coolant temperature, electronic lock status, intelligent device software version, signal strength of smart devices, current setting of the dashboard.',
    bindingText5:
      'Vehicle Alarm Data: alarm data to be sent if certain data exceeds a preset value, such as engine temperature, excessive speed, excessive driving time, high coolant temperature, abnormal vehicle movement, abnormal tire pressure, vibration, dumping, collision, etc.',
    bindingText6: 'Vehicle Fault Information: refers to the fault codes reported by each internal part of the Vehicle.',
    bindingText7: 'Vehicle Location Data: refers to the specific geographical whereabouts of the Vehicle.',
    bindingText8: '1.1.\tProviding the Customer with vehicle-related services through the CFMOTO RIDE APP.',
    bindingText9: '1.1.1.\tThe Consumers can remotely manage vehicles through the CFMOTO RIDE APP (including viewing the vehicle location, setting the vehicle information, and functions, remote control of vehicle status, etc.).',
    bindingUser: 'Binding user',
    bound: 'Bound',
    businessType: 'Business type',
    button: 'Button',
    callbackedApply: 'You withdrew your account deletion application on yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      'Your account deletion request was submitted on yyyy-MM-dd HH:mm:ss. We will permanently delete your account and related data 15 days after receiving this request. After deletion, you will no longer be able to use the CFMOTO RIDESYNC service. To cancel your account deletion, please revisit this web page or log into the app within 15 days to withdraw your account deletion request.',
    callbackedApplyTip:
      'Your account deletion request was submitted on yyyy-MM-dd HH:mm:ss. We will permanently delete your account and related data 15 days after receiving this request. After deletion, you will no longer be able to use the CFMOTO RIDE service. To cancel your account deletion, please revisit this web page or log into the app within 15 days to withdraw your account deletion request.',
    cancel: 'Cancel',
    cancellationAgreement: 'Cancellation agreement',
    cancelled: 'Cancelled',
    carOwner: 'Owner',
    carUserScore: 'Vehicle owner ratings',
    cardPass: 'Successful identity verification!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Switch to verification code authentication',
    changeDescriptionType: 'Change description',
    changeDescriptionTypeSelectNo: 'Does not involve changes in personal information processing regulations',
    changeDescriptionTypeSelectYes: 'Changes in regulations involving the processing of personal information',
    changeEmailInfo: 'Switch to email',
    changeFail: 'Status modification failed',
    changeOne: 'Change',
    changePassValidate: 'Switch to password authentication',
    changePasswordFailed: 'Password change failed',
    changePasswordSuccessful: 'Password change successful',
    changePhoneInfo: 'Switch to phone number',
    changeStore: 'Change store',
    changeSuccess: 'Status modified successfully',
    channelType: 'Feedback channel',
    characterLimitExceeded: 'Character limit exceeded',
    checkConfigurationTwo: 'Chinese or English %s is not fully configured. Please check.',
    checkCopyWriting: 'The Chinese or English content is not filled in. Please check.',
    checkEmpty: '%s is empty. Please check.',
    checkTriggerType: 'A trigger mechanism condition has not been filled in. Please check.',
    checkUpdate: 'Check updates',
    cityFilter: 'City filter',
    clickImmediateFeedback: 'Click to give feedback now',
    clickNumber: 'Number of clicks',
    clickNumberDescription: 'The actual number of clicks by users after the notification message is successfully displayed (clicks after 5 days will not be counted)',
    clickNumberVolume: 'Number of clicks',
    clickToFeedback: 'Click to give feedback',
    clicks: 'Clicks',
    closeNum: 'Closure',
    closeTask: 'Task terminated',
    code: 'Verification code',
    colorPicture: 'Color block image',
    comment: 'Comment',
    commentContent: 'Comments',
    commentList: 'Comment list',
    commentNumber: 'Number of comments',
    commentTime: 'Comment time',
    communication: 'Communication',
    community: 'Community',
    communityManagement: 'Community management',
    communityRule: 'Community rule',
    completePuzzle: 'Please complete the puzzle',
    completed: 'Completed',
    condition: 'Condition',
    configureLanguage: 'Configure language',
    configurePicture: 'Configure picture',
    confirm: 'Confirm',
    confirmDeletePictures: 'Confirm to delete this picture',
    confirmReviewNoPass: 'Confirm to fail the review',
    confirmReviewPass: 'Confirm to pass the review',
    consultDealer: 'Please consult your local dealer',
    contact: 'Your account deletion application was rejected. If you have questions, please contact appsupport@cfmotousa.com.',
    contactMail: 'Email address',
    contactMethod: 'Contact',
    contactUs: 'Contact us',
    content: 'Content',
    contentType: 'Content type',
    copyFail: 'Copy failed',
    copyLink: 'Copy link',
    copySuccess: 'Copied successfully',
    copyWriting: 'Pop-up content',
    country: 'Country/region',
    countryCode: 'Country code',
    countryName: 'Country',
    countryNumber: 'Country code',
    countryRegion: 'Country/region',
    create: 'New addition',
    createBy: 'Creator',
    createStore: 'Create store',
    createTime: 'Creation time',
    cs_CZ: 'Czech',
    currency: 'Currency',
    currentConfig: 'Current configuration',
    currentCountryStoreTotal: 'Total number of stores in current country',
    currentTime: 'Current time',
    customPage: 'Custom page',
    customSettings: 'Custom settings',
    dataDeletExplain: 'Data deletion guidance',
    dataDelete: 'Data deletion',
    dataDeleteApply: 'Data deletion request',
    dataFormatError: 'Data format error',
    dataPermissionScope: 'Data permission scope',
    dataType: 'Data type',
    dayOne: 'Days once',
    days: 'Days',
    daysAgo: '%s days ago',
    de_DE: 'German',
    dealDate: 'Processing time',
    dealerOperationList: 'Dealer operation list',
    dealerOperationQuery: 'Dealer operation query',
    dealerOperationRecord: 'Dealer operation record',
    dealerStore: 'Dealer stores',
    dealerStoreImportTempateName: 'Dealer store import template',
    dealerStoreQuery: 'Dealer stores query',
    dealers: 'Importer',
    default: 'Default',
    defaultMap: 'Default map',
    delete: 'Delete',
    deleteAccountSYNCStep: 'You can follow these steps to request the deletion of your CFMOTO RIDESYNC account',
    deleteAccountStep: 'You can follow these steps to request the deletion of your CFMOTO RIDE account',
    deleteDataSYNCStep: 'You can follow these steps to request the deletion of your CFMOTO RIDESYNC data',
    deleteDataStep: 'You can follow these steps to request the deletion of your CFMOTO RIDE data',
    deleteFail: 'Deletion failed',
    deleteFinish: 'Deletion completed',
    deleteKolUserAuthentication: 'Delete KOL user authentication',
    deleteStore: 'Delete store',
    deleteSuccess: 'Deletion successful',
    deleteTip: 'Are you sure you want to delete this post? Once deleted, the information cannot be recovered.',
    deleteVersionWarn: 'Delete this version record?',
    deleteVideo: 'Delete this video?',
    detailAddress: 'Full address',
    details: 'Details',
    determine: 'Sure',
    deviceCodeGet: 'Get device code:',
    deviceContent:
      'The geo-fence receiver equipment code (the "key") is a string of 10-digit codes. The equipment code, QR code and CE mark are printed on a silver PVC sticker. There are three labels in total. One is affixed to the vehicle body (you need to lift the seat cushion to view it). The other two are placed in the vehicle accessory bag. It is recommended that users affix these labels on the vehicle owner\'s manual and on the geo-fence remote control.',
    deviceNo: 'T-Box No.',
    deviceNumber: 'Device number',
    deviceTitle: 'Device code check',
    digitalKey: 'Digital key',
    digitalKeyDesc: 'Carrying a physical key is unnecessary. You can unlock the vehicle after the app connects via Bluetooth (supported by some models).',
    directRelease: 'Direct release',
    disagree: 'Disagree',
    displayNumberDescription: 'The actual number of successful displays on the device terminal after the notification message arrives (displays after 5 days will not be counted)',
    displayNumberVolume: 'Number of displays',
    displayOrder: 'Display order',
    displayPicture: 'Presentation diagram',
    donwloadTemplateDescription: 'Please download the template first, fill it in (only text content is supported), and then upload the completed file. File size is limited to 2MB. If the submission fails, please reduce content appropriately.',
    download: 'Download',
    downloadFailFile: 'Download failed file',
    downloadSuccessful: 'Download successful',
    downloadTemplate: 'Download template',
    downloading: 'Downloading...',
    ebookChoice: 'Language Choice',
    ebookEmpty: 'No instruction',
    ebookPlaceholder: 'Please input the frame number',
    ebookSwitch: 'Change Language',
    ebookTitle: 'ebook',
    edit: 'Edit',
    editAccountDeletExplain: 'Edit account deletion notes',
    editActivity: 'Edit activity',
    editAppRating: 'Edit rating mechanism',
    editBanner: 'Edit Banner',
    editDataDeletExplain: 'Edit data deletion notes',
    editExhibitionCategory: 'Edit Shop Category',
    editExhibitionSeries: 'Edit Series',
    editFunctionIntro: 'Edit function introduction',
    editInformation: 'Edit information',
    editInformationCategory: 'Edit information category',
    editInformationContent: 'Edit information content',
    editKolUserAuthentication: 'Edit KOL user authentication',
    editModelSeries: 'Edit model series',
    editPicture: 'Edit picture',
    editPushConfiguration: 'Edit push configuration',
    editRemark: 'Edit Remark',
    editServiceIntroduce: 'Introduction to editing services',
    editShowroomModel: 'Edit showroom models',
    editSuccess: 'Edited successfully',
    editTime: 'Edit time',
    editUnbindingCommitment: 'Edit unbinding application commitment',
    editUser: 'Edit user',
    editVehicleModel: 'Edit model',
    editVehicleModelCategory: 'Edit vehicle category',
    effecting: 'Pending activation',
    effectiveTime: 'Effective date',
    electricVehicle: 'Electric Vehicle',
    email: 'Email',
    emailAdress: 'Email address',
    emailAdressTip: 'Note: This email address is used for customer contact. Please ensure that the email address is correct.',
    emailContent: 'Content of email',
    emailImportTemplate: 'Email address import template',
    emailImportTemplateToDownLoad: 'Email addresses can be imported in batches. Click to download.',
    emailList: 'Email list',
    emailManage: 'Email management',
    emailMass: 'Email blast',
    emailSearch: 'Email query',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'Email',
    emailTitle: 'Subject',
    en_US: 'English',
    enableStatus: 'Enabled status',
    enabled: 'Enable',
    endTime: 'End time',
    endTimeLargeStartTime: 'End time must be later than start time',
    enterAnswer: 'Please enter the answer',
    enterCategory: 'Please enter the category',
    enterCodeToSafeAccount: 'To ensure the security of your account, please confirm your account information you wish to delete, and enter your password or a verification code to authenticate your identity.',
    enterCodeToSafeData: 'To ensure the security of your data, please confirm your account information, and enter your password or a verification code to authenticate your identity.',
    enterIntroduceText: 'Please enter introductory text',
    enterLink: 'Please enter the link address',
    enterPopupTitle: 'Please enter the pop-up window title',
    enterQueryConditionLookData: 'After entering the query conditions, you can view the data',
    enterQuestion: 'Please enter a question',
    enterQuestionAndAnswer: 'Questions and answers in Chinese and English are required',
    enterSureUrl: 'Please enter the correct URL (the URL must start with "http" or "https")',
    enterTypeOfLanguage: 'Chinese and English categories must be filled in',
    enterUnbindingCommitment: 'Please enter a commitment letter for the unbinding application',
    entrance: 'entrance',
    errorLatAndLon: 'The latitude and longitude are formatted incorrectly. Please check.',
    errorLocation: 'Location error',
    es_ES: 'Spanish',
    estimatedTime: 'Estimated time',
    everySet: 'Per setting',
    examineResultMessage: 'We will verify the application materials as soon as possible. Please monitor the notification bar or app message center.',
    example: 'Example',
    exhibition: 'Shop Management',
    exhibitionCategory: 'Shop Category',
    exhibitionCategoryList: 'Shop Category List',
    exhibitionCategorySearch: 'Shop Category Query',
    exhibitionSeries: 'Shop Series',
    exhibitionSeriesList: 'Shop Series List',
    exhibitionSeriesSearch: 'Shop Series Query',
    exportContent: 'Export content',
    exportExcel: 'Export to EXCEL',
    exportLengthExceedOfMonth: 'Export length not to exceed %s months',
    externalLink: 'External link',
    failed: 'Failed',
    failedToPreview: 'Review failed',
    feedBackResut: 'Feedback results',
    feedBackTime: 'Feedback time',
    feedBackVechle: 'Vehicle',
    feedbackAppQuestion: 'Please describe in detail the time of occurrence, APP version, cell phone model, operation path and problem description to help quickly locate and troubleshoot the problem!',
    feedbackDetails: 'Feedback details',
    feedbackGuideDesc: 'For more information, please contact us via the feedback channel below',
    feedbackLabelFileList: 'Please upload pictures(<5) or a video, picture size< 5MB, video size < 50MB',
    feedbackMapQuestion:
      'If you find that the address or street information displayed in the APP map is inconsistent with the actual situation, please provide your area, the current problem address (or street) information, and actual road information. The more detailed the problem description is, the easier it will be for us to troubleshoot and accurately update the map data.',
    feedbackMessageSubmitError: 'Feedback failed',
    feedbackOtherQuestion: 'Please describe when it happened, how it happened and the problem',
    feedbackReceived: 'Feedback received',
    feedbackRecord: 'Feedback record',
    feedbackRulesFileListMaxSize: 'The uploaded file is too large',
    feedbackRulesFileListOverType: 'Unsupported format',
    feedbackSubmitTip: 'If you have questions or comments, you can also contact the CFMOTO Mexico Customer Service Center directly via WhatsApp (+52 18115286003) or email (servicioalclient@cfmoto.com.mx)',
    feedbackSuggest: 'Welcome to make valuable suggestions, we will seriously consider your ideas',
    feedbackSupplement: 'Please add a description of the problem',
    feedbackText: 'Feedback',
    feedbackType: 'Feedback',
    feedbackVehicleQuestion: 'Please describe when it happened, how it happened and the problem',
    female: 'Female',
    fileCountExceed: 'The number of files exceeds the limit',
    fileSizeExceed: 'File size exceeds limit',
    fileUploadingPleaceWait: 'File is uploading - please wait',
    finalOperator: 'Final operator',
    firstMenu: 'First menu',
    forcedUpgrade: 'Forced update',
    forgetPassword: 'Forget password ?',
    fourCarOfNumber: 'Number of four-wheeler users',
    fourWheel: 'Four-wheeler',
    fourWheelConfig: 'Adult four-wheel vehicle configuration',
    fourWheeler: 'Four-wheeler',
    fourWheelerMostClicks: 'Four-wheeler models with the most clicks',
    fourWheelowner: 'Adult four-wheel vehicle owners',
    fr_FR: 'French',
    frankfurt: 'Frankfurt',
    friday: 'Friday',
    fuctionIntro: 'Function introduction',
    fullscreen: 'Full screen',
    funServiceIntro: 'Function service introduction',
    function: 'Function',
    functionConfiguration: 'Function configuration',
    functionConfigureTip: 'The function is only applicable to configured vehicles under the name of the importer or users in the country/region',
    functionDescription: 'Functions are only available for vehicles of the configured importer',
    functionDetail: "Configuration (according to the vehicle's importer)",
    functionIntroduce: 'Function description',
    functionSetting: 'Map off-road function configuration',
    functionalOverview: 'Overview',
    galleryEntrance: 'Gallery entrance',
    galleryEntranceUploadRules: 'Format requirements: jpg/jpeg/png, recommended ratio 4:3, size no more than 5 MB',
    gender: 'Gender',
    generalAlarm: 'General alarm',
    geofence: 'Geofence',
    getCarPosition: 'Get vehicle location',
    getCode: 'Send',
    goCustomPage: 'Go to custom page',
    goOffline: 'Offline',
    goOnline: 'Online',
    goUrlLink: 'Go to URL link',
    groupTrail: 'Group Trail',
    groupTrailConfig: 'Group Trail function configuration',
    guest: 'Guest',
    haveTwo: 'Both of them',
    havedWrite: 'is filled in',
    havedWriteAll: 'have been filled in',
    havedWriteAllOrEmpty: 'is filled in or empty',
    helpAndFeedback: 'Help & feedback',
    helpCenter: 'Help center',
    helpMessageHistoryDelete: 'Delete all search records?',
    helpful: 'Helpful',
    hint: 'Hint',
    historyDelete: 'Delete all search records?',
    home: 'Home page',
    homePage: 'Personal Home Page',
    hour: 'Hour',
    hoursAgo: '%s hours ago',
    iWantEnableStoreUserQuery: 'I want to enable store user query',
    iWantToPostStatistics: 'I want to post statistics',
    identification: 'Identification',
    identificationText: 'Identification',
    imageSizeExceed: 'Please upload an image with a width and height of %s',
    imageUploadFailed: 'Image upload failed',
    immediateSend: 'Send now',
    imporFailedOfTableHeader: 'Import failed. File header did not match.',
    import: 'Import',
    importDetails: 'Question details',
    importExcel: 'Import Excel',
    importFail: 'Import failed',
    importStatus: 'Import status',
    importSuccessful: 'Import successful',
    importTemplate: 'EXCEL template',
    importer: 'importer',
    importerAccountOperationRecord: 'Importer account operation and login record',
    importerAvatar: 'Importer avatar',
    importerDisplayName: 'Importer display name',
    importerEnquiry: 'Importer enquiry',
    importing: 'Importing...',
    inProcess: 'In process',
    inProgress: 'In progress',
    individualCenter: 'Individual center',
    informationCategory: 'Information category',
    informationCategoryList: 'List of information categories',
    informationCategoryQuery: 'Information category query',
    informationContent: 'Information content',
    informationContentList: 'Information content list',
    informationCotnentQuery: 'Information content query',
    informationCover: 'Information cover',
    informationDetails: 'Information details',
    informationImage: 'Cover image',
    informationManagement: 'Information management',
    informationTitle: 'Information title',
    informer: 'Informer',
    informerId: 'Informer ID',
    initialPassword: 'Initial password',
    inputAgreementContent: 'Please enter the content of the agreement',
    inputErrorEmoji: 'Please do not enter emoticons',
    installDeviceYouCan: 'Installing this device allows you to',
    installVehicleModelAdd: 'Add description of retrofitted vehicle model',
    installVehicleModelDescription: 'Description of the retrofitted model',
    installVehicleModelEdit: 'Edit description of retrofitted vehicle model',
    instrumentLastedVersion: 'TFT display no need to upgrade',
    instrumentupgrade: 'TFT display upgrade',
    intelligentInternetServiceIntroduction: 'Service introduction',
    introText: 'Intro text',
    introduction: 'Introduction',
    invalidVercode: 'Invalid verification code',
    iovNotice1: 'The above functions are based on a vehicle networking device (T-Box). Please consult a local dealer to buy and install one.',
    iovNotice2: 'The above functions differ by the configuration of each model and the region where it is located. Please consult a local dealer for details.',
    iovNotice3: 'Please save and record the device number in advance, which is required when binding the device. After completing the binding and installation, you can experience more functions.',
    isHelpful: 'Does it help?',
    isStop: 'Stop?',
    isSupportedChildOwnerOffMapDown: 'Whether non-adult vehicle owners support offline map download',
    isSupportedNoOwnerOffMapDown: 'Whether non-vehicle owners support offline map download',
    isSupportedOffMapDown: 'Whether offline map download is supported',
    it_IT: 'Italian',
    iterativeVehicleFunctions: 'The main parts of the vehicle can be upgraded online remotely to continuously iterate vehicle functions.',
    jumpSettings: 'Jump settings',
    jumpTarget: 'Jump target',
    jumpToWeb: 'Explore More on Our Website',
    jumpUrl: 'Redirect Link',
    justNow: 'Just now',
    kolUserList: 'List of KOL users',
    kolUserManagement: 'KOL user management',
    kolUserQuery: 'KOL user query',
    language: 'Language',
    language1: 'Associated language',
    languages: 'Language',
    lastLoginTime: 'Last login time',
    lastModifiedBy: 'Last modified by',
    lastUpdateTime: 'Last updated time',
    latitude: 'Latitude',
    launchActivity: 'Launch activity',
    likeNumber: 'Number of likes',
    linkAddress: 'Link address',
    linkUrlDescription: 'The URL must start with "http" or "https"',
    listDisplayImages: 'List display',
    listOfImporters: 'List of importers',
    listOfQuestion: 'List of questions',
    listShowStoreCoverPic: 'Listings show store cover art',
    loadSuccess: 'Loading complete',
    loading: 'Loading',
    locationFail: 'Unable to obtain current location',
    log: 'Log',
    login: 'Log in',
    loginCountry: 'Login country/region',
    logout: 'Log out',
    longitude: 'Longitude',
    loosing: 'Refreshing data...',
    lowCompatibleVersion: 'Minimum compatible version',
    mail: 'Email',
    male: 'Male',
    manualReviewStatus: 'Manual review status',
    mapManage: 'Map management',
    marketDataOfdealerStores: 'Market data of dealer stores',
    masteringCyclingData: 'Master riding data',
    maximum: 'Max.',
    maximumBannerCountTip: 'A maximum of %s banners can be online at the same time. Please remove at least one first.',
    maximumValue: 'Maximum',
    menuFunctionName: 'Menu function name',
    menuIcon: 'Menu icon',
    messagePush: 'Message push',
    messagePushDeleteAsk: 'Delete this push?',
    messagePushDownloadTemplate: 'Please download the template first, fill it in, and then upload the completed file. File size is limited to 2 MB. If the submission fails, please reduce content appropriately.',
    messageWithdrawAsk: 'Withdraw this push?',
    middle: 'Middle',
    min: 'Min',
    minAgo: '%s min ago',
    minimum: 'Min.',
    minimumValue: 'Minimum',
    modelDetail: 'Model details',
    modifyFail: 'Modification failed',
    modifyPassword: 'Modify password',
    modifySuccess: 'Editing successful',
    monday: 'Monday',
    more4pic1video: 'Maximum is 4 pictures / 1 video',
    morning: 'morning',
    motorcycle: 'Motorcycle',
    moveDown: 'Move downward',
    moveLongPressMap: 'Move or long press the map to select a location',
    moveMapSelectPoint: 'Move map to select point',
    moveTo: 'Move to',
    moveToBottom: 'Move to the bottom',
    moveToTop: 'Move to the top',
    moveToTopStatus: 'Move to top',
    moveTop: 'Top setting',
    moveUp: 'Move upward',
    multimedia: 'Multimedia',
    mustInteger: 'Must be a positive integer',
    mute1Day: 'Mute for 1 day',
    mute2Days: 'Mute for 2 days',
    mute30Days: 'Mute for 30 days',
    mute3Days: 'Mute for 3 days',
    mute7Days: 'Mute for 7 days',
    muting: 'Muting',
    nameOfImporter: 'Name of importer',
    navigation: 'Map navigation',
    nearLoginTime: 'Last login time',
    needPopup: 'Need pop-up window',
    negativeNum: 'Bad review',
    networkException: 'Network exception',
    newAddFail: 'Addition failed',
    newAddSuccess: 'Added successfully',
    newBanner: 'New Banner',
    newCancellationAgreement: 'New cancellation agreement',
    newFunctionIntro: 'New function introduction',
    newMenuFunction: 'New menu function',
    newModelSeries: 'New model series',
    newPassword: 'New password',
    newPasswordNotEqual: 'The new password entered twice is inconsistent, please re-enter',
    newQuestionType: 'Add new question categories',
    newStoreNumber: 'Number of new stores',
    newTopic: 'New topic',
    newUnbindingCommitment: 'New unbundling commitment form',
    nextStep: 'Next',
    nickName: 'Nickname',
    no: 'No',
    noContent: 'No related content',
    noContent2: 'Suggest changing keywords or',
    noData: 'No data',
    noFeedbackRecord: 'There are no feedback records at the moment',
    noJump: 'No jump',
    noLog: 'No log',
    noNeedPopup: 'No pop-ups required',
    noOkToFeedback: 'Unsolved - need more help',
    noOwnerScore: 'Non-owner ratings',
    noPass: 'Fail',
    noSendPeople: 'No sender',
    noSupportMapDown: 'Offline map download is not supported',
    noThisPermission: 'No permission for this operation',
    noUserSelected: 'No user was selected, so submission cannot proceed',
    nofiledSeviceContent: 'Service introduction is not filled in',
    nonOwner: 'Non-owner',
    nonVehicleOwnerCharged: 'Non-vehicle owners will be charged after trial',
    none: 'None',
    normal: 'Normal',
    notAllowImageAndVideo: 'Video cannot be selected when selecting images',
    notAllowed: 'Not allowed',
    notBeLessOrEqual: 'Shall not be less than or equal to',
    notDeleted: 'Not deleted',
    notDistributedYet: 'Not distributed yet',
    notEnabled: 'Not enabled',
    notHelpful: 'Not helpful',
    notLessThan: 'Must not be less than',
    notRecommended: 'Not recommended',
    notReleasedYet: 'Not released yet',
    notStarted: 'Has not started',
    notTop: 'Not to the top',
    notice: 'Notice',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. We are committed to enhancing service quality and implementing innovative improvements, and we have made business adjustments due to this commitment. As of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In its place, we have launched the brand-new CFMOTO RIDESYNC App. We hope you continue to enjoy our services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this App will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that you will have a richer and more satisfying user experience with this service upgrade. If you encounter issues or have questions during this process, we are here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Version numbers cannot all be 0',
    offline: 'Offline',
    offlineAlready: 'Off-line',
    offlineTime: 'Offline time',
    offlineTimeMustBeGreaterThan: 'Offline time must be greater than',
    ok: 'OK',
    oldPassword: 'Old password',
    onLineAlready: 'onLineAlready',
    oneMonths: 'One month',
    oneYear: 'One year',
    online: 'Online',
    onlyFourWheel: 'Four-wheelers only',
    onlyTwoWheel: 'Two-wheelers only',
    openEveryCount: 'Open every time',
    openEveryDay: 'Open every day',
    openProductType: 'Open product types',
    operationRecord: 'Operation record',
    operationTime: 'Operation time',
    operations: 'Operations',
    operator: 'Operator',
    opreate: 'opreate',
    opreateFunSet: 'opreateFunSet',
    opreateFunSetAdvert: 'opreateFunSetAdvert',
    opreateFunSetAdvertAdd: 'opreateFunSetAdvertAdd',
    opreateFunSetAdvertEdit: 'opreateFunSetAdvertEdit',
    opreateFunSetAdvertView: 'opreateFunSetAdvertView',
    optionalUpgrade: 'Optional update',
    orderList: 'Order list',
    orderMange: 'Order management',
    orderNum: 'Order number',
    otaUpgradeVehicle: 'OTA upgrade vehicle',
    otaUpgradeVehicleDesc: 'The main components of the vehicle can be upgraded remotely to continuously iterate vehicle performance.',
    other: 'Other',
    over: 'Over',
    owner: 'Owner',
    ownerIdHomepageImage: "Main page of ID card, driver's license or passport that contains personal identification information.",
    parameterConfiguration: 'Parameter configuration',
    partialImportFailed: 'Partial import failed',
    pass: 'Pass',
    passValidateDeleteAccount: 'Successful identity verification! Click the Submit Request button at the bottom to apply for account deletion.',
    password: 'Password',
    passwordRuleText: '8-20 characters, must contain uppercase and lowercase English letters, numbers, special characters',
    passwordRules: 'Password rules',
    paySetting: 'Map charging management',
    payStrategy: 'Payment strategy',
    peleaseEnterProvince: 'Please enter state/province',
    pendSend: 'Pending',
    pending: 'Pending',
    permanentMuting: 'Muted permanently',
    phoneModel: 'Model',
    phoneNum: 'Phone number',
    phoneNumber: 'Phone number',
    phoneOrEmail: 'Phone number/E-mail',
    phoneOrEmailImportTemplate: 'Mobile phone number/email address import template',
    phoneOrEmailNotRegistered: 'This cell phone number or email address is not registered',
    phoneOrEmailOrUserId: 'Mobile phone number/e-mail address/user ID',
    picture: 'Picture',
    pl_PL: 'Polish',
    pleaseAddImage: 'Please add image files',
    pleaseAddVideoFile: 'Please add video files',
    pleaseEnter: 'Please enter',
    pleaseEnterAccountInfo: 'Please enter account information',
    pleaseEnterAmount: 'Please enter the amount',
    pleaseEnterCity: 'Please enter a city',
    pleaseEnterEmail: 'Please enter your email address',
    pleaseEnterEmailAdress: 'Please enter the email address',
    pleaseEnterIntro: 'Please enter introduction',
    pleaseEnterLatAndLong: 'Please enter the latitude and longitude',
    pleaseEnterNewPassword: 'Input the new password',
    pleaseEnterPassword: 'Please input password',
    pleaseEnterPhone: 'Please enter your phone number',
    pleaseEnterQuestionDescription: 'Please enter a description of your problem',
    pleaseEnterRealname: 'Please enter your real name',
    pleaseEnterRemark: 'Please enter remarks',
    pleaseEnterServePhone: 'Please enter the service number',
    pleaseEnterStoreAddressDetail: 'Please enter address details',
    pleaseEnterStoreIntroduce: 'Please enter store introduction',
    pleaseEnterStoreName: 'Please enter the store name',
    pleaseEnterStoreRemarkName: 'Please enter the store remark name',
    pleaseEnterTitle: 'Please enter a title',
    pleaseEnterUsername: 'Enter the username',
    pleaseEnterVercode: 'Enter vercode',
    pleaseEnterVersion: 'Please enter the version number',
    pleaseEnterVersionIntroduction: 'Please enter the version introduction',
    pleaseEnterVideoDetail: 'Please enter video details',
    pleaseEnterVin: 'Please enter the VIN',
    pleaseInputWord: 'Please enter a keyword',
    pleaseLoginFirst: 'Please login first',
    pleaseRepeatNewPassword: 'please repeat new password',
    pleaseSelect: 'Please choose',
    pleaseSelectBusinessHours: 'Please select the business hours',
    pleaseSelectCity: 'Please select a city',
    pleaseSelectCountry: 'Please select a country',
    pleaseSelectCurrency: 'Please select a currency',
    pleaseSelectMatchingMultimediaContent: 'Please select the matching multimedia content',
    pleaseSelectPayChannel: 'Please select a payment channel',
    pleaseSelectProblemWhere: 'Please select a scenario in which the problem occurs',
    pleaseSelectProducType: 'Please select product type',
    pleaseSelectProvince: 'Please select a state/province',
    pleaseSelectQueType: 'Please select the type of question',
    pleaseSelectReportReason: 'Please select the reason for reporting',
    pleaseSelectStatus: 'Please select status',
    pleaseSelectStoreType: 'Please select store type',
    pleaseSelectTimedSendTime: 'Please select sending time',
    pleaseSelectUserTheList: 'Please select a user from the list',
    pleaseSelectVehicle: 'Please select a vehicle',
    pleaseSelectVehicleConfig: 'Please select vehicle configuration',
    pleaseSelectupgradeType: 'Please select the update method',
    pleaseSureType2: 'Please make sure everything was entered',
    pleaseUpload: 'Please upload',
    pleaseUploadPicVideo: 'Please upload pictures/videos',
    popUpFrequencyType: 'Pop-up window form',
    popUpFrequencyValue: 'Pop-up frequency',
    popUpFrequencyValueValid: 'Please select frequency in days',
    popUpReminder: 'Pop up a reminder?',
    popupArea: 'pop-up user range',
    popupCreate: 'Add pop-up window',
    popupDayOne: 'Once per set number of days',
    popupEdit: 'Edit pop-up window',
    popupFrequency: 'Pop-up frequency',
    popupManagement: 'Pop-up window management',
    popupOne: 'Play only once',
    popupPosition: 'Pop-up window location',
    popupStatus: 'Pop-up status',
    popupTarget: 'Pop-up target',
    popupTime: 'Pop-up time',
    popupTitle: 'Pop-up window title',
    positiveNum: 'Good reviews',
    postComment: 'Post comment',
    postContent: 'Post content',
    postId: 'Post ID',
    postList: 'Post list',
    postManagement: 'Post management',
    postSearch: 'Post search',
    posts: 'Posts',
    precautionText1: 'Hello! We will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States on 08/10/2024. Please note the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the App.',
    precautionText3: '2. To ensure a smooth transition to the new replacement service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. You will no longer be able to enjoy any services of the App in the United States after its discontinuation. At that time, we will delete all personal data generated during your use of the App in accordance with the relevant laws and regulations. This means that we will not be able to respond to requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may inconvenience you, but we are committed to continuously protecting your data and privacy. We encourage you to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy quality service from CFMOTO. If you have questions or need assistance in this process, please contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Privacy policy details',
    privacyPolicy: 'Privacy policy',
    privacyPopupAgree: "Re-obtain the user's consent to the privacy policy through a pop-up window",
    privacyVersion: 'Privacy policy version',
    privacyVersionList: 'Privacy policy version list',
    problemaDes: 'Problem description',
    processMethod: 'Processing methods',
    processReason: 'Reason for processing',
    processReasonDetails: 'Details for processing reason',
    processRecord: 'Processing record',
    processReport: 'Process reports',
    processSolution: 'Processing solution',
    processUser: 'Process user',
    processed: 'Processed',
    productDetails: 'Product details',
    productTime: 'production time',
    prohibitDecimalsAndNegative: 'Decimals and negative numbers are prohibited',
    pt_PT: 'Portuguese',
    publishInformation: 'Publish information',
    publishPosts: 'Publish posts',
    pullBefore: 'Pull down to refresh',
    pulling: 'Release refresh now',
    purchaseAndInstall: 'Buy and install',
    pushConfiguration: 'Push configuration',
    pushContent: 'Push content',
    pushList: 'Push list',
    pushMode: 'Push mode',
    pushNow: 'Push now',
    pushQuery: 'Push query',
    pushRecord: 'Push record',
    pushScope: 'Push scope',
    pushTime: 'Push time',
    pushTimeDifferenceAsk: 'The chosen sending time may prevent some users from receiving this push due to time differences. Are you sure you want to save?',
    pushTitle: 'Push title',
    pushed: 'Pushed',
    pushing: 'Pushing',
    query: 'Search',
    question: 'Question',
    questionInquiry: 'Question inquiry',
    questionType: 'Question type',
    questionTypeList: 'Question classification list',
    questionTypeTemplate: 'Help center - problem classification template',
    quickRelease: 'Quick release',
    ranking: 'Ranking',
    ratingWarn1: 'For vehicle owners, the smart service control corresponding to the country/region in the management background has not been turned on or the smart service has not expired after being turned on. The vehicle is online and has',
    ratingWarn2: 'one or more complete riding records (the start and end of each ride are a reported event). A pop-up will appear when the user exits My Cycling and returns to the home page.',
    reUpgrade: 'Retry',
    readAgree: 'Read and agree to the',
    readAndAgree: 'Please read and agree',
    readAndAgreeTo: 'I have read and agreed to the',
    readDeleteStep: 'Understand the types of data we will delete or retain, and any additional retention periods',
    realname: 'Real name',
    reasonForReport: 'Reason for reporting',
    receiveCarReminderMessage: 'Receive vehicle message alerts',
    rechargeAmount: 'Recharge amount',
    rechargeChannel: 'Recharge channels',
    rechargeStatus: 'Recharge status',
    rechargeTime: 'Recharge time',
    recharged: 'Recharged',
    recipients: 'Recipient',
    recipientsNum: 'Recipient scope',
    recommended: 'Recommended',
    recommendedStatus: 'Recommended status',
    redirectUrl: 'Redirect URL',
    refreshInterval: 'Refresh interval',
    refreshSend: 'Resend',
    refundFailed: 'Refund failed',
    refunded: 'Refunded',
    refunding: 'Refund in progress',
    refused: 'Rejected',
    registerDate: 'Registration time',
    rejected: 'Rejected',
    releaseContent: 'Release content',
    releaseMute: 'Release the mute',
    releaseTime: 'Release time:',
    released: 'Released',
    releasedBy: 'Released by',
    remark: 'Notes',
    rememberPassword: 'Remember the password',
    reminder: 'Reminder',
    remove: 'Remove',
    removeOnlinUpgrade: 'Remove online upgrade vehicle',
    repeatNewPassword: 'Repeat the new password',
    replaceTBOX: 'Replace TBOX',
    replied: 'Replied',
    reply: 'Reply',
    report: 'Report',
    reportList: 'Report list',
    reportManagement: 'Report management',
    reportReason: 'Reason for reporting',
    reportReasonDetails: 'Details for reporting reason',
    reportReasonPlaceholder: 'Write what you want to report, 0-1500 words',
    reportSearch: 'Report search',
    reportSuccessful: 'Successful report, we will deal with it as soon as possible',
    reportTime: 'Reporting time',
    reportType: 'Type of report',
    reportedContent: 'Reported content',
    reportedUser: 'Reported user',
    reportedUserId: "Reported user's ID",
    requestTimedOut: 'Request timed out',
    reset: 'Reset',
    return: 'Return',
    review: 'Review',
    reviewApproved: 'Review passed',
    richText: 'Rich text',
    ro_RO: 'Romanian',
    roleDescription: 'Role description',
    roleName: 'Role name',
    rolePermission: 'Role permission',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'Russian',
    safeRemind: 'To protect your account security, please do not upload information that is unrelated to your issues (for example, your password, personal photos, etc.)',
    satelliteMap: 'Satellite map',
    saturday: 'Saturday',
    save: 'Save',
    saveAndPreview: 'Save and preview',
    saveFail: 'Failed to save',
    savePicture: 'Save picture',
    saveSettings: 'Save settings',
    saveSuccess: 'Saved successfully',
    saveVideo: 'Save video',
    scanQrcodePreview: 'Scan the QR code below with your mobile phone to preview',
    screenNavigationGuidance: 'Setup instructions',
    sdkStatement: 'SDK statement',
    search: 'Search',
    searchRecords: 'Historical search',
    secondaryMenu: 'Secondary menu',
    securityMessage: 'The above information is used only for identity verification. CFMOTO safeguards your information.',
    select: 'Select',
    selectAll: 'Select all',
    selectAuthentication: 'Select authentication',
    selectChannelType: 'Please select a feedback channel',
    selectCountry: 'Select country',
    selectData: 'Please select the data you wish to delete, and click the Submit button at the bottom to submit your data deletion request',
    selectDate: 'Select date',
    selectEnableStatus: 'Please select enabled status',
    selectFeedBackState: 'Select feedback processing status',
    selectFeedbackType: 'Please select a feedback type',
    selectJumpTarget: 'Please select jump target',
    selectLanguage: 'Please select language',
    selectOneCarType: 'Select at least one model',
    selectPoint: 'Select point',
    selectPopupFrequency: 'Please select pop-up frequency',
    selectPopupPosition: 'Please select the pop-up window location',
    selectPopupTarget: 'Please select pop-up target',
    selectPopupTime: 'Please select pop-up time',
    selectRejectReason: 'Please select a reason for rejection',
    selectTheLanguage: 'Select the language',
    selectTime: 'Select time',
    selectUser: 'Select users',
    selectVehicle: 'Select vehicle',
    selectionOfImporter: 'Selection of importer',
    sendNumberDescription: 'Among the effective target devices, the Aurora server successfully creates the number of devices to send tasks',
    sendNumberVolume: 'Number of sends',
    sendType: 'Sending method',
    sendUserNum: 'Number of users',
    sending: 'Sending',
    serial: 'No.',
    seriesBackground: 'Series Background Image',
    seriesDesc: 'Series Description',
    seriesIntroduction: 'Series introduction',
    seriesName: 'Series Name',
    seriesShowcase: 'Series showcase',
    seriesUplodImgRule: 'The image format is required to be jpg/jpeg/png with a recommended ratio of 9:16, resolution of 1080 or 1920x1080 pixels, and a maximum size of 5 MB.',
    seriousAlarm: 'Serious alarm',
    serviceIntroduction: 'Service introduction',
    serviceText: 'Service',
    settingSuccess: 'Set successfully',
    shareNumber: 'Number of shares',
    sheet: 'Sheet',
    show: 'More',
    showPicturesOfVideos: 'Show pictures/videos',
    showroomModel: 'Showroom model',
    showroomModelList: 'Showroom model list',
    showroomModelQuery: 'Showroom model inquiry',
    showroomUploadRules: 'The image format requirement is jpg/jpeg/png, the image ratio is 9:19.5, the image size cannot exceed 5 MB, and the video size cannot exceed 50 MB.',
    signOut: 'Automatic termination',
    singapore: 'Singapore',
    sixMonths: 'Six months',
    slideToRight: 'Swipe right',
    smartServices: 'Smart Services',
    someUser: 'Some users',
    sort: 'Sort',
    source: 'Source',
    sr_YU: 'Serbian',
    startChecking: 'Start checking',
    startTime: 'Start time',
    statisticalTime: 'Statistical time',
    status: 'Status',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. Click the button below [Download CFMOTO RIDESYNC] or download the CFMOTO RIDESYNC App from Apple Store/Google Play.',
    stepText3: '2. After installing the CFMOTO RIDESYNC App, open it, enter its login page, and log in with your existing CFMOTO RIDE account and password.',
    stepText4:
      '3. After you enter your account and password correctly, the app will pop up a prompt window asking whether to start data migration. Click OK only when you are ready. The migration process is uninterruptable. If you select "Cancel" during this step, you will not be able to log into the app again.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If the migration fails, contact appsupport@cfmotousa.com.',
    stepText6:
      '5. After data migration finishes, you will automatically enter the vehicle home page of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the app normally, and you will be able to access all the data you previously saved in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log into the CFMOTO RIDESYNC App with your CFMOTO RIDE account if you wish to migrate data. Your data will not be migrated if you choose to register a new account or log in with another account. In addition, after successful data migration, your original CFMOTO RIDE account will no longer be accessible in the CFMOTO RIDE App. Please proceed carefully to ensure safe migration of your data.',
    stop: 'Stop',
    store: 'Store',
    storeAddressCountryTip: 'Note: This store address is the main way for users to find you. Please ensure that the address is correct.',
    storeAddressDetail: 'Store address',
    storeAddressDetailTip: 'Example: detailed address: 813 Howard Street Oswego NY 13126 USA',
    storeAddressPosition: 'Latitude and longitude',
    storeAddressPositionTip:
      'Longitude: the integer part of longitude is a whole number from -180 to 180, and the decimal part is a decimal not exceeding 15 digits.\\nLatitude: the integer part of latitude is a whole number from -90 to 90, and the decimal part is not more than 15 decimal places.',
    storeBusinessType: 'Store type',
    storeImage: 'Store image',
    storeImportTemplateText: 'Please download the template, fill in the dealer store information in the template file, then upload the file; the file size is limited to 1MB; if submission fails, please reduce the content or upload in batches',
    storeIntroduce: 'Store introduction',
    storeList: 'Store list',
    storeMange: 'Store management',
    storeName: 'Store name',
    storeNameTip: 'Note: Please select a language supported by the system to fill in the store name',
    storeQueryUserStatistics: 'Store query user statistics',
    storeRemarkName: 'Store remark name',
    storeRemarkNameTip: 'Note: If the language supported by the system does not meet your needs, you can enter the store remark name in the language you want here.',
    storeSearch: 'Stores query',
    storeServicePhone: 'Service phone number',
    storeServicePhoneTip: 'Note: This phone number is used for customer contact. Please make sure that the phone number is correct.',
    storeServiceTime: 'Opening time',
    storeStatistics: 'Store statistics',
    storeUploadImageRequire: 'Image format requirements are jpg/jpeg/png. The size of a single picture cannot exceed 5 MB, and a total of 9 or fewer images can be imported.',
    storefront: 'Store',
    submissionFailed: 'Submission failed, please try again',
    submit: 'Submit',
    submitAccountDeleteApply: 'Submit the account deletion request',
    submitDataDeleteApply: 'Submit the data deletion request',
    submitFeedback: 'Submit feedback',
    submitted: 'Submitted',
    successful: 'Successful',
    sunday: 'Sunday',
    supportMapDown: 'Offline map download is supported',
    supportedChannel: 'Supported channels',
    sureAgree: 'Agree?',
    sureBackApply: 'Withdraw account deletion application?',
    sureDelete: 'Once deleted, it cannot be recovered. Are you sure you want to delete it',
    sureDeleteData: 'Delete the selected data? Once confirmed, the data is immediately deleted and cannot be recovered.',
    sureDeleteSeries: 'Delete this Series?',
    sureDeleteSetting: 'Are you sure to delete this payment setting',
    sureDeleteStoreInfo: 'Delete this store information? After deletion, the information cannot be recovered.',
    sureReject: 'Reject?',
    sureSuspend: 'Sending will stop after termination. Are you sure you want to terminate',
    suspend: 'Terminate',
    sv_SE: 'Swedish',
    switchLanguage: 'Switch the language',
    system: 'System',
    systemBusy: 'System is busy, please try again later',
    systemVersion: 'System version',
    tboxIntro: 'T-Box is the key device to realize the intelligent network connection function of vehicles',
    teamConfigTip: 'We will open the Rides function (team off-road) for vehicles that meet the above configuration conditions. Fees will be charged after the function is opened',
    threeMonths: 'Three months',
    thursday: 'Thursday',
    time: 'Time',
    timeSend: 'Timed send',
    timedOffline: 'Timed off-line',
    timedPush: 'Timed push',
    timedRelease: 'Timed release',
    timedSendTime: 'Send time',
    tips: 'Tips',
    title: 'Title',
    to: 'To',
    toBeReleased: 'To be released',
    topMenu: 'Top menu',
    topicContent: 'Topic content',
    topicList: 'List of topics',
    topicManagement: 'Topic management',
    topicSearch: 'Topic search',
    topicTitle: 'Topic title',
    totalAndlLayoutOfStores: 'Total number and layout of stores',
    totalClicks: 'Total clicks',
    totalNumber: 'Total times',
    tr_TR: 'Turkish',
    triggerNum: 'Number of triggers',
    tuesday: 'Tuesday',
    turnOn: 'turn on',
    twoCarAndFourCarOfNumber: 'Number of two-wheeler and four-wheeler users',
    twoCarOfNumber: 'Number of two-wheeler users',
    twoWheelConfig: 'Adult two-wheel vehicle configuration',
    twoWheeler: 'Two-wheeler',
    twoWheelerAndFourWheeler: 'Two-wheeler and four-wheeler',
    twoWheelerMostClicks: 'Two-wheeler models with the most clicks',
    twoWheelowner: 'Adult two-wheel vehicle owners',
    typeMessage: 'Feedback type',
    types: 'Type',
    unbind: 'Unbound',
    unbindingCommitment: 'Commitment for unbinding',
    unbindingLabelRealName: 'Your full name',
    unbound: 'Unbound',
    understandRealtimeConditions: "Receive vehicle reminder messages, such as for vehicle vibrations and geo-fence entries and exits, and understand the vehicle's status in real time.",
    uninstallTboxDesc: "For vehicles that do not have a T-Box installed, you can view basic vehicle information (such as the frame number, engine number and owner's manual) after binding.",
    unitCurrencyPer: 'Unit currency per',
    unitMonth: 'Month',
    unlimited: 'Unlimited',
    unpaid: 'Unpaid',
    unprocessed: 'Unprocessed',
    unresolved: "Still can't solve? Click",
    unspecified: 'Unspecified',
    upToTopics: 'Up to %s topics can be added',
    updateAuthenticationTime: 'Update authentication time',
    updateBy: 'Update',
    updateSuccess: 'Update completed',
    updateTime: 'Update time',
    updating: 'updating',
    upgradeAgainDescription: 'The upgrade task has been re-pushed. Please follow the 【Guide】 on the top of the current page to connect the tft display  network to upgrade.',
    upgradeAssistant: 'Guide',
    upgradeDescription: 'When new version is found, please follow the 【Guide】 on the top of the current page to connect the tft display  network to upgrade.',
    upgradeSuccessful: 'Update successful',
    upgradeType: 'Update method',
    upload: 'Upload',
    uploadDisplayPicture: 'Please upload a display picture',
    uploadFail: 'Upload failed',
    uploadFailed: 'Upload failed. Please try another network.',
    uploadFailedOfTry: 'Upload failed, please try again',
    uploadFileMore1M: 'Upload file size does not exceed 1M',
    uploadFiles: 'Upload file',
    uploadImageRules1To1: 'The image format is required to be jpg/jpeg/png with a 1:1 image ratio and a maximum size of 5 MB',
    uploadLog: 'Upload log',
    uploadPicture: 'Upload picture',
    uploadQuantityExceed: 'The number of uploads exceeds the limit',
    uploadSuccessful: 'Upload successful',
    uploadTime: 'Upload time',
    uploadTip556_740: 'Please upload an image with a width and height of 556 x 740',
    uploadVideoRules: 'Only one video file can be uploaded. The size of a single video cannot exceed 50 MB.',
    uploadVideoRules4To3: 'Recommended video ratio is 4:3, and its size cannot exceed 50 MB',
    urlLink: 'URL link',
    user: 'User',
    userEmail: 'E-mail',
    userGender: 'User gender',
    userId: 'User ID',
    userIdTemplate: 'User ID Import Template',
    userIdentity: 'User ID',
    userLocalTime: "User's local time",
    userLogin: 'Login',
    userMobilePhone: 'User mobile phone',
    userModel: "User's model",
    userName: 'Username',
    userName1: 'User name',
    userNickname: "User's nickname",
    userNum: 'User number',
    userPhone: 'Mobile phone number',
    userRealName: 'Real name',
    userReply: 'Pending user reply',
    userStatus: 'User status',
    userType: 'User type',
    userUnbind: 'User unbind',
    users: 'Users',
    vacationTime: 'Vacation time',
    validNumberVolume: 'Number of valid targets',
    validNumerDescription: 'The target crowd selected by the push task and the number of target devices after effectiveness screening',
    validateEmail: 'Email address format is wrong. Please check.',
    validateImageRadio: 'Picture file format requirements: %s, picture scale: %s, no more than %s',
    validateImageSize: 'Picture file format requirements: %s, recommended picture size: %s, no more than %s',
    validatePhone: 'Phone number format is wrong. Please check.',
    validateVideo: 'Video file format requirements: %s, no more than %s',
    validateVin: 'VIN is wrong. Please check.',
    vehicleAlarmDetails: 'Vehicle alarm details',
    vehicleBindDuration: 'Vehicle binding duration',
    vehicleBrochure: 'Vehicle brochure',
    vehicleColor: 'Vehicle color',
    vehicleDetails: 'Vehicle details',
    vehicleDrivingLicense: 'Vehicle registration certificate',
    vehicleFaultDetails: 'Vehicle Fault details',
    vehicleGallery: 'Vehicle gallery',
    vehicleGalleryEntranceConfiguration: "The app's motorcycle showroom page and vehicle gallery function entrance pictures are all taken from the following configuration. Please ensure that the three pictures are completed in the configuration.",
    vehicleGalleryEntranceSettings: 'Vehicle gallery entrance settings',
    vehicleGalleryUploadRules: 'The image format requirement is jpg/jpeg/png. The size of a single image should not exceed 5 MB. A maximum of 10 images can be imported at a time. Multiple imports are allowed.',
    vehicleIdHomepageImage: "VRC main page with owner's name and VIN",
    vehicleModel: 'Vehicle model',
    vehicleModelAlbum: 'Model brochure',
    vehicleModelCategorySort: 'Sort by vehicle category',
    vehicleModelDescription: 'Model description',
    vehicleModelList: 'Model list',
    vehicleModelManagement: 'Vehicle model management',
    vehicleModelName: 'Model name',
    vehicleModelQuery: 'Vehicle model query',
    vehicleModelSeries: 'Model series',
    vehicleModelSorting: 'Model sorting',
    vehicleModelType: 'Model type',
    vehicleName: 'Vehicle name',
    vehicleNetworkEquipment: 'Vehicle networking device',
    vehicleOutboundCountry: 'Vehicle outbound country',
    vehicleRemark: 'Vehicle remark',
    vehicleShareInstruction: 'Vehicle sharing instructions',
    vehicleShareInstructionAdd: 'New vehicle sharing instructions',
    vehicleShareInstructionEdit: 'Edit vehicle sharing instructions',
    vehicleType: 'Vehicle type',
    vehicleTypeSplicing: 'Feedback model',
    vehicleUnbindingInstructions: 'Instructions for vehicle unbinding application',
    versionCode: 'Version number',
    versionIntroduction: 'Version introduction',
    versionManage: 'Version management',
    versionManageList: 'Version management list',
    versionMangeTip:
      'Note: Creating a version number larger than the one currently posted in the app market is not allowed! Operation and maintenance personnel need to wait for the latest version to be released on Google Play or the App Store, and then they can create version records corresponding to the latest version number. Creating records in advance is not allowed.',
    versionPattern: 'The version number can be entered only as an integer from 0 to 999',
    versionRequired: 'The version number cannot be empty',
    video: 'Video',
    videoContent: 'Video content',
    videoCover: 'Video cover',
    videoDetail: 'Video details',
    videoDisplayImages: 'Video display',
    videoFile: 'Video file',
    videoGuide: 'Video boot configuration',
    videoImageValidate: 'Image file format requirements: png/jpg/jpeg format, image ratio 16:9, no more than 5 MB in size.',
    videoList: 'Video list',
    videoMaxSizeValidate: 'Video size cannot exceed 150 MB',
    videoSizeExceed: 'Please upload a video with a width and height of %s',
    viewAllComment: 'View all comments',
    viewCount: 'Viewing count',
    viewCurrentLocation: 'Open the app to view the current location of the vehicle',
    viewCurrentLocation2: 'Open the app to view the current location of the vehicle, which is convenient for finding vehicles at close range',
    viewDetails: 'View details',
    viewFeedBackRecords: 'View feedback records',
    viewLocation: 'Open the app to check the current location of the vehicle',
    viewModel: 'View this model',
    viewPush: 'View push',
    viewSeries: 'View Series',
    viewVehicleInfomation: 'View the daily riding track, mileage, duration, speed and other information of the vehicle.',
    views: 'Views',
    vin: 'VIN',
    virginia: 'Virginia',
    waitForReview: 'Waiting for review',
    waitUploading: 'Uploading - please wait',
    waitingManualReview: 'Waiting for manual review',
    waitingOnline: 'waitingOnline',
    waitingPush: 'Waiting',
    wednesday: 'Wednesday',
    whatOTA: 'What is OTA?',
    whyUseNavigation: 'How to use the navigation',
    whyUseSetting: 'How to make general settings',
    withCountry: 'Country/region (IP)',
    withInformation: 'With information',
    withTBOX: 'With TBOX',
    withdrawn: 'Withdrawn',
    withoutCarOfNumber: 'Number of users without a car',
    withoutTBOX: 'Without TBOX',
    writeAccountToPass: 'Fill in account information and complete identity verification',
    year: 'Year',
    yes: 'Yes',
    youHaveFeedbackMessage: 'You have ** user feedback that has not been effectively followed up, please deal with it in time',
    youthVehicleOwner: 'Youth vehicle owners',
    yoyGrowth: 'Increased by  YoY',
    zh_CN: 'Chinese',
  },
};
